/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiCreateScenario,
    InternalApiCreateScenarioFromJSON,
    InternalApiCreateScenarioToJSON,
    InternalApiScenario,
    InternalApiScenarioFromJSON,
    InternalApiScenarioToJSON,
    InternalApiScenarioBasicDetails,
    InternalApiScenarioBasicDetailsFromJSON,
    InternalApiScenarioBasicDetailsToJSON,
    InternalApiScenarioCategory,
    InternalApiScenarioCategoryFromJSON,
    InternalApiScenarioCategoryToJSON,
    InternalApiScenarioComputedParameter,
    InternalApiScenarioComputedParameterFromJSON,
    InternalApiScenarioComputedParameterToJSON,
    InternalApiScenarioEntityType,
    InternalApiScenarioEntityTypeFromJSON,
    InternalApiScenarioEntityTypeToJSON,
    InternalApiScenarioHistoryItem,
    InternalApiScenarioHistoryItemFromJSON,
    InternalApiScenarioHistoryItemToJSON,
    InternalApiScenarioOption,
    InternalApiScenarioOptionFromJSON,
    InternalApiScenarioOptionToJSON,
    InternalApiScenarioStatus,
    InternalApiScenarioStatusFromJSON,
    InternalApiScenarioStatusToJSON,
    InternalApiScenarioTypeV2,
    InternalApiScenarioTypeV2FromJSON,
    InternalApiScenarioTypeV2ToJSON,
    InternalApiScenarioTypology,
    InternalApiScenarioTypologyFromJSON,
    InternalApiScenarioTypologyToJSON,
    InternalApiSortDirection,
    InternalApiSortDirectionFromJSON,
    InternalApiSortDirectionToJSON,
    InternalApiUpdateScenario,
    InternalApiUpdateScenarioFromJSON,
    InternalApiUpdateScenarioToJSON,
    InternalScenariosBasicPage,
    InternalScenariosBasicPageFromJSON,
    InternalScenariosBasicPageToJSON,
} from '../models';

export interface CreateScenarioRequest {
    internalApiCreateScenario: InternalApiCreateScenario;
}

export interface DeleteScenarioRequest {
    scenarioHandle: string;
}

export interface FindAllScenarioTypologiesRequest {
    categoryId: string;
}

export interface FindAllScenariosRequest {
    page: number;
    size: number;
    types: Array<InternalApiScenarioTypeV2>;
    statuses: Array<InternalApiScenarioStatus>;
    orderByStatus: InternalApiSortDirection;
    orderByUpdatedTime: InternalApiSortDirection;
    query?: string;
    entityType?: InternalApiScenarioEntityType;
    categoryIds?: Array<string>;
}

export interface FindComputedParametersRequest {
    scenarioHandle: string;
}

export interface GetScenarioRequest {
    scenarioHandle: string;
}

export interface GetScenarioHistoryRequest {
    scenarioHandle: string;
}

export interface UpdateScenarioRequest {
    scenarioHandle: string;
    internalApiUpdateScenario: InternalApiUpdateScenario;
}

/**
 * 
 */
export class ScenarioInternalApi extends runtime.BaseAPI {

    /**
     * Create a custom scenario
     */
    async createScenarioRaw(requestParameters: CreateScenarioRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScenarioBasicDetails>> {
        if (requestParameters.internalApiCreateScenario === null || requestParameters.internalApiCreateScenario === undefined) {
            throw new runtime.RequiredError('internalApiCreateScenario','Required parameter requestParameters.internalApiCreateScenario was null or undefined when calling createScenario.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/scenarios`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiCreateScenarioToJSON(requestParameters.internalApiCreateScenario),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScenarioBasicDetailsFromJSON(jsonValue));
    }

    /**
     * Create a custom scenario
     */
    async createScenario(requestParameters: CreateScenarioRequest, initOverrides?: RequestInit): Promise<InternalApiScenarioBasicDetails> {
        const response = await this.createScenarioRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete an existing scenario
     */
    async deleteScenarioRaw(requestParameters: DeleteScenarioRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.scenarioHandle === null || requestParameters.scenarioHandle === undefined) {
            throw new runtime.RequiredError('scenarioHandle','Required parameter requestParameters.scenarioHandle was null or undefined when calling deleteScenario.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/scenarios/{scenarioHandle}`.replace(`{${"scenarioHandle"}}`, encodeURIComponent(String(requestParameters.scenarioHandle))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an existing scenario
     */
    async deleteScenario(requestParameters: DeleteScenarioRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteScenarioRaw(requestParameters, initOverrides);
    }

    /**
     * Fetches all scenario categories
     */
    async findAllScenarioCategoriesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiScenarioCategory>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/scenarios/categories`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiScenarioCategoryFromJSON));
    }

    /**
     * Fetches all scenario categories
     */
    async findAllScenarioCategories(initOverrides?: RequestInit): Promise<Array<InternalApiScenarioCategory>> {
        const response = await this.findAllScenarioCategoriesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Fetches scenario options
     */
    async findAllScenarioOptionsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiScenarioOption>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/scenarios/options`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiScenarioOptionFromJSON));
    }

    /**
     * Fetches scenario options
     */
    async findAllScenarioOptions(initOverrides?: RequestInit): Promise<Array<InternalApiScenarioOption>> {
        const response = await this.findAllScenarioOptionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Fetches all scenario typologies
     */
    async findAllScenarioTypologiesRaw(requestParameters: FindAllScenarioTypologiesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiScenarioTypology>>> {
        if (requestParameters.categoryId === null || requestParameters.categoryId === undefined) {
            throw new runtime.RequiredError('categoryId','Required parameter requestParameters.categoryId was null or undefined when calling findAllScenarioTypologies.');
        }

        const queryParameters: any = {};

        if (requestParameters.categoryId !== undefined) {
            queryParameters['categoryId'] = requestParameters.categoryId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/scenarios/typologies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiScenarioTypologyFromJSON));
    }

    /**
     * Fetches all scenario typologies
     */
    async findAllScenarioTypologies(requestParameters: FindAllScenarioTypologiesRequest, initOverrides?: RequestInit): Promise<Array<InternalApiScenarioTypology>> {
        const response = await this.findAllScenarioTypologiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Finds all scenarios by filters
     */
    async findAllScenariosRaw(requestParameters: FindAllScenariosRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalScenariosBasicPage>> {
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling findAllScenarios.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findAllScenarios.');
        }

        if (requestParameters.types === null || requestParameters.types === undefined) {
            throw new runtime.RequiredError('types','Required parameter requestParameters.types was null or undefined when calling findAllScenarios.');
        }

        if (requestParameters.statuses === null || requestParameters.statuses === undefined) {
            throw new runtime.RequiredError('statuses','Required parameter requestParameters.statuses was null or undefined when calling findAllScenarios.');
        }

        if (requestParameters.orderByStatus === null || requestParameters.orderByStatus === undefined) {
            throw new runtime.RequiredError('orderByStatus','Required parameter requestParameters.orderByStatus was null or undefined when calling findAllScenarios.');
        }

        if (requestParameters.orderByUpdatedTime === null || requestParameters.orderByUpdatedTime === undefined) {
            throw new runtime.RequiredError('orderByUpdatedTime','Required parameter requestParameters.orderByUpdatedTime was null or undefined when calling findAllScenarios.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.entityType !== undefined) {
            queryParameters['entityType'] = requestParameters.entityType;
        }

        if (requestParameters.types) {
            queryParameters['types'] = requestParameters.types;
        }

        if (requestParameters.statuses) {
            queryParameters['statuses'] = requestParameters.statuses;
        }

        if (requestParameters.categoryIds) {
            queryParameters['categoryIds'] = requestParameters.categoryIds;
        }

        if (requestParameters.orderByStatus !== undefined) {
            queryParameters['orderByStatus'] = requestParameters.orderByStatus;
        }

        if (requestParameters.orderByUpdatedTime !== undefined) {
            queryParameters['orderByUpdatedTime'] = requestParameters.orderByUpdatedTime;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/scenarios`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalScenariosBasicPageFromJSON(jsonValue));
    }

    /**
     * Finds all scenarios by filters
     */
    async findAllScenarios(requestParameters: FindAllScenariosRequest, initOverrides?: RequestInit): Promise<InternalScenariosBasicPage> {
        const response = await this.findAllScenariosRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches computed parameters that can be used in this scenario
     */
    async findComputedParametersRaw(requestParameters: FindComputedParametersRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiScenarioComputedParameter>>> {
        if (requestParameters.scenarioHandle === null || requestParameters.scenarioHandle === undefined) {
            throw new runtime.RequiredError('scenarioHandle','Required parameter requestParameters.scenarioHandle was null or undefined when calling findComputedParameters.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/scenarios/{scenarioHandle}/parameters`.replace(`{${"scenarioHandle"}}`, encodeURIComponent(String(requestParameters.scenarioHandle))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiScenarioComputedParameterFromJSON));
    }

    /**
     * Fetches computed parameters that can be used in this scenario
     */
    async findComputedParameters(requestParameters: FindComputedParametersRequest, initOverrides?: RequestInit): Promise<Array<InternalApiScenarioComputedParameter>> {
        const response = await this.findComputedParametersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get scenario
     */
    async getScenarioRaw(requestParameters: GetScenarioRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScenario>> {
        if (requestParameters.scenarioHandle === null || requestParameters.scenarioHandle === undefined) {
            throw new runtime.RequiredError('scenarioHandle','Required parameter requestParameters.scenarioHandle was null or undefined when calling getScenario.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/scenarios/{scenarioHandle}`.replace(`{${"scenarioHandle"}}`, encodeURIComponent(String(requestParameters.scenarioHandle))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScenarioFromJSON(jsonValue));
    }

    /**
     * Get scenario
     */
    async getScenario(requestParameters: GetScenarioRequest, initOverrides?: RequestInit): Promise<InternalApiScenario> {
        const response = await this.getScenarioRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get scenario history
     */
    async getScenarioHistoryRaw(requestParameters: GetScenarioHistoryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiScenarioHistoryItem>>> {
        if (requestParameters.scenarioHandle === null || requestParameters.scenarioHandle === undefined) {
            throw new runtime.RequiredError('scenarioHandle','Required parameter requestParameters.scenarioHandle was null or undefined when calling getScenarioHistory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/scenarios/{scenarioHandle}/history`.replace(`{${"scenarioHandle"}}`, encodeURIComponent(String(requestParameters.scenarioHandle))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiScenarioHistoryItemFromJSON));
    }

    /**
     * Get scenario history
     */
    async getScenarioHistory(requestParameters: GetScenarioHistoryRequest, initOverrides?: RequestInit): Promise<Array<InternalApiScenarioHistoryItem>> {
        const response = await this.getScenarioHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing scenario
     */
    async updateScenarioRaw(requestParameters: UpdateScenarioRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScenario>> {
        if (requestParameters.scenarioHandle === null || requestParameters.scenarioHandle === undefined) {
            throw new runtime.RequiredError('scenarioHandle','Required parameter requestParameters.scenarioHandle was null or undefined when calling updateScenario.');
        }

        if (requestParameters.internalApiUpdateScenario === null || requestParameters.internalApiUpdateScenario === undefined) {
            throw new runtime.RequiredError('internalApiUpdateScenario','Required parameter requestParameters.internalApiUpdateScenario was null or undefined when calling updateScenario.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/scenarios/{scenarioHandle}`.replace(`{${"scenarioHandle"}}`, encodeURIComponent(String(requestParameters.scenarioHandle))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiUpdateScenarioToJSON(requestParameters.internalApiUpdateScenario),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScenarioFromJSON(jsonValue));
    }

    /**
     * Update an existing scenario
     */
    async updateScenario(requestParameters: UpdateScenarioRequest, initOverrides?: RequestInit): Promise<InternalApiScenario> {
        const response = await this.updateScenarioRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
